import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, Button } from "@mui/material"
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";


const ConfirmDialog = ({open, setOpen, setCheck}) => {



  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle sx={{
        backgroundColor: "#2d232a",
        fontSize: 24,
        fontWeight: 900,
        color: "#ce361e",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
      }}>
        {" "}
        <ErrorOutlineIcon sx={{ fontSize: 50 }} /> Critical Operation{" "}
        <ErrorOutlineIcon sx={{ fontSize: 50 }} />
      </DialogTitle>
      <DialogContent sx={{ backgroundColor: "#2d232a" }}>
        <Typography sx={{ fontSize: 19, fontWeight: 600, color: "orange" }}>
          Are you sure you want to proceed with the operation about Probe
          Mode?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ backgroundColor: "#2d232a" }}>
        <Button
          variant="outline"
          sx={{
            backgroundColor: "#a02e1c",
            mt: 3,
            mb: 2,
            "&:hover": {
              backgroundColor: "whitesmoke !important",
              color: "#131C2D",
            },
          }}
          onClick={() => setCheck(true)}
        >
          Confirm
        </Button>
        <Button
          sx={{
            backgroundColor: "#877976",
            mt: 3,
            mb: 2,
            "&:hover": {
              backgroundColor: "whitesmoke !important",
              color: "#131C2D",
            },
          }}
          variant="outline"
          onClick={() => setOpen(false)}
          autoFocus
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDialog;
